import './faq-search.scss'

;( function( $ ) {

	const HIGHLIGHT_CLASS = 'm-faq__highlight'
	const ACTIVE_CLASS = '-active'

	/**
	 * Simple debounce helper
	 */
	const debounce = ( fn, delay ) => {

		let timeout

		return ( ...args ) => {

			clearTimeout( timeout )
			timeout = setTimeout( () => fn( ...args ), delay )

		}

	}

	/**
	 * Remove existing highlights inside an element
	 * and normalise text nodes so words are not split
	 * over many individual nodes.
	 */
	const clearHighlights = ( $container ) => {

		$container.find( `.${ HIGHLIGHT_CLASS }` ).each( function() {

			const $this = $( this )
			$this.replaceWith( $this.text() )

		} )

		// Merge adjacent text nodes so subsequent searches
		// can find multi-character queries again.
		const normalizeTextNodes = ( node ) => {

			if ( ! node || ! node.childNodes ) {
				return
			}

			let child = node.firstChild

			while ( child ) {

				if ( child.nodeType === Node.TEXT_NODE ) {

					let next = child.nextSibling

					while ( next && next.nodeType === Node.TEXT_NODE ) {

						child.nodeValue += next.nodeValue
						const toRemove = next
						next = next.nextSibling
						node.removeChild( toRemove )

					}

				} else if ( child.nodeType === Node.ELEMENT_NODE ) {

					normalizeTextNodes( child )

				}

				child = child.nextSibling

			}

		}

		$container.each( function() {

			normalizeTextNodes( this )

		} )

	}

	/**
	 * Apply highlighting to plain text nodes that match the query.
	 * This avoids breaking existing HTML structure in answers.
	 */
	const highlightMatches = ( $container, query ) => {

		if ( ! query ) {
			return
		}

		const lowerQuery = query.toLowerCase()

		$container.contents().each( function() {

			const node = this

			if ( node.nodeType === Node.TEXT_NODE ) {

				const text = node.nodeValue
				const lowerText = text.toLowerCase()

				if ( ! text || lowerText.indexOf( lowerQuery ) === -1 ) {
					return
				}

				const frag = document.createDocumentFragment()

				let searchIndex = 0

				while ( true ) {

					const index = lowerText.indexOf( lowerQuery, searchIndex )

					if ( index === -1 ) {
						break
					}

					const before = text.slice( searchIndex, index )
					const match = text.slice( index, index + query.length )

					if ( before ) {
						frag.appendChild( document.createTextNode( before ) )
					}

					const mark = document.createElement( 'mark' )
					mark.className = HIGHLIGHT_CLASS
					mark.textContent = match
					frag.appendChild( mark )

					searchIndex = index + query.length

				}

				const after = text.slice( searchIndex )

				if ( after ) {
					frag.appendChild( document.createTextNode( after ) )
				}

				node.parentNode.replaceChild( frag, node )

			} else if ( node.nodeType === Node.ELEMENT_NODE ) {

				highlightMatches( $( node ), query )

			}

		} )

	}

	/**
	 * Ensure a FAQ item is opened (answer visible) without breaking slideToggle.
	 */
	const openFaqItem = ( $faq ) => {

		const $question = $faq.find( '.m-faq__question' ).first()
		const $answer = $faq.find( '.m-faq__answer' ).first()

		if ( ! $question.length || ! $answer.length ) {
			return
		}

		$question.addClass( ACTIVE_CLASS )
		$answer.stop( true, true ).slideDown( 0 )

	}


	/**
	 * Reset a FAQ item to its default collapsed state.
	 */
	const resetFaqItem = ( $faq ) => {

		const $question = $faq.find( '.m-faq__question' ).first()
		const $answer = $faq.find( '.m-faq__answer' ).first()

		if ( $question.length ) {
			$question.removeClass( ACTIVE_CLASS )
			clearHighlights( $question )
		}

		if ( $answer.length ) {
			clearHighlights( $answer )
			$answer.stop( true, true ).slideUp( 0 )
		}

		$faq.show()

	}

	/**
	 * Get searchable text (question + answer) from a FAQ item
	 */
	const getFaqText = ( $faq ) => {

		const questionText = $faq.find( '.m-faq__question' ).text() || ''
		const answerText = $faq.find( '.m-faq__answer' ).text() || ''

		return ( questionText + ' ' + answerText ).toLowerCase()

	}

	const initFaqSearch = () => {

		const $input = $( '.js-faqSearchInput' ).first()

		if ( ! $input.length ) {
			return
		}

		const $status = $( '.o-faqSearch__status' ).first()
		const $faqs = $( '.m-faq' )

		if ( ! $faqs.length ) {
			return
		}

		// Cache original searchable text for each FAQ so DOM changes (like highlights)
		// do not affect matching across subsequent searches.
		$faqs.each( function() {

			const $faq = $( this )
			const searchText = getFaqText( $faq )

			$faq.data( 'searchText', searchText )

		} )

		let lastFirstMatch = null

		const performSearch = () => {

			const queryRaw = $input.val() ? String( $input.val() ) : ''
			const query = queryRaw.trim().toLowerCase()

			if ( ! query ) {

				// Empty query: reset state (all FAQs visible, collapsed, no highlights)
				$faqs.each( function() {

					const $faq = $( this )
					resetFaqItem( $faq )

				} )

				lastFirstMatch = null

				if ( $status.length ) {
					$status.text( '' )
				}

				return

			}

			let firstMatchElement = null
			let matchCount = 0

			$faqs.each( function() {

				const $faq = $( this )
				const text = $faq.data( 'searchText' ) || getFaqText( $faq )

				if ( text.indexOf( query ) === -1 ) {

					// Items without matches remain visible but collapsed
					resetFaqItem( $faq )
					return

				}

				matchCount++

				const $question = $faq.find( '.m-faq__question' )
				const $answer = $faq.find( '.m-faq__answer' )

				clearHighlights( $question )
				clearHighlights( $answer )

				highlightMatches( $question, query )
				highlightMatches( $answer, query )

				openFaqItem( $faq )

				if ( ! firstMatchElement ) {
					firstMatchElement = $faq.get( 0 )
				}

			} )

			if ( $status.length ) {

				if ( matchCount === 0 ) {

					// No matches: keep all FAQs visible in a collapsed default state
					$faqs.each( function() {

						const $faq = $( this )
						resetFaqItem( $faq )

					} )

					$status.text( 'Geen resultaten gevonden' )

				} else {

					$status.text( '' )

				}

			}

			if ( firstMatchElement && firstMatchElement !== lastFirstMatch ) {

				lastFirstMatch = firstMatchElement

				const rect = firstMatchElement.getBoundingClientRect()
				const absoluteTop = rect.top + window.pageYOffset

				window.scrollTo( {
					top: absoluteTop - 40,
					behavior: 'smooth',
				} )

			}

		}

		const debouncedSearch = debounce( performSearch, 200 )

		$input.on( 'input', debouncedSearch )

	}

	$( document ).ready( initFaqSearch )

} )( jQuery )